// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"041bf182","676":"871b7133","688":"169f4bd8","787":"2615a0fe"}[chunkId] + ".chunk.js";
};